import { StyledMainContent } from "./styled";
import { IMainContentProps } from "./types";
import { useDrawerStore } from "src/store/drawerStore";

const MainContent = ({children, ...props}:IMainContentProps)=>{
    const open = useDrawerStore((s: any) => s.open);
    return (
        <StyledMainContent open={open} {...props}>
            {children}
        </StyledMainContent>
    )
}

export {MainContent}